import React from 'react';
import { Monitor, ArrowRight } from 'lucide-react';

interface DemoMobileCTAProps {
  onContactClick: () => void;
}

export function DemoMobileCTA({ onContactClick }: DemoMobileCTAProps) {
  return (
    <div className="bg-gsp-navy/5 rounded-xl p-6 text-center">
      {/* Icon */}
      <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-gsp-teal/10 flex items-center justify-center">
        <Monitor className="w-7 h-7 text-gsp-teal" />
      </div>

      {/* Message */}
      <h4 className="text-lg font-semibold text-gsp-text-primary mb-2">
        Best Experienced on Desktop
      </h4>
      <p className="text-sm text-gsp-text-body mb-6">
        Our document analyzers work best on desktop where you can easily upload your files.
        Visit this page on your computer to try them out.
      </p>

      {/* CTA */}
      <button
        onClick={onContactClick}
        className="inline-flex items-center gap-2 px-6 py-3 bg-gsp-orange text-white rounded-lg font-semibold hover:bg-gsp-orange/90 transition-colors"
      >
        Get in Touch
        <ArrowRight className="w-4 h-4" />
      </button>

      <p className="mt-4 text-xs text-gsp-text-body">
        Or email us at{' '}
        <a href="mailto:info@propvetter.com" className="text-gsp-teal hover:underline">
          info@propvetter.com
        </a>
      </p>
    </div>
  );
}

export default DemoMobileCTA;
